import React, { useState } from "react";
import "./Experience.css";
import { FaAngleRight } from "react-icons/fa";

function Experience() {
  const experiences = [
    {      companyName: "Quantiverse Global",
      companyLink: "#",
      role: "Software Engineering Intern (Remote)",
      date: "Dec 2025 – Jan 2026",
      bullets: [
        "Analyzed the existing application architecture, data flow, and frontend-backend interactions to understand system dependencies.",
        "Designed and implemented a new Supabase database schema after the original database became unavailable, ensuring continuity of the application.",
        "Updated backend APIs to integrate with the newly structured database while maintaining compatibility with the existing frontend.",
        "Collaborated using Git for version control, debugging, and iterative development in a team environment.",
        "Gained experience working with real production systems, database redesign under practical limitations, and maintaining backward compatibility.",
      ],
    },
    {
      companyName: "Electrolyte Solutions",
      companyLink: "#",
      role: "Software Engineering Intern (Remote)",
      date: "Dec 2025 – Jan 2026",
      bullets: [
        "Migrated a non-responsive WordPress website into a custom web application using the MERN stack (React, Node.js, Express, MongoDB).",
        "Implemented file upload and asset management workflows using Multer for handling media and document storage.",
        "Applied SEO best practices such as semantic HTML structure, metadata optimization, and performance enhancements to improve discoverability.",
        "Built a responsive, performance-focused web application modernizing a legacy system.",
      ],
    },
    {      companyName: "Tinkerer’s ECS Lab",
      companyLink: "#",
      role: "Technical Officer",
      date: "July 2024 – Present",
      bullets: [
        "Facilitated hands-on sessions in Web development and IoT, empowering practical and technical understanding.",
        "Provided personalized guidance during workshops, optimizing hardware configurations and resolving technical challenges.",
        "Coordinated workshop logistics and curriculum development for cutting-edge web and IoT technologies.",
        "Assisted in developing prototype projects that demonstrated practical applications of emerging technologies.",
      ],
    },
    {
      companyName: "Vivekanand Education Society’s Institute of Technology",
      companyLink: "#",
      role: "Technical Support Manager",
      date: "June 2024 – Present",
      bullets: [
        "Troubleshot and resolved networking, database, and system performance issues.",
        "Ensured proper functioning of servers, databases, and online assessment platforms.",
        "Documented technical solutions and created guides for efficient troubleshooting.",
        "Managed maintenance of campus-wide digital infrastructure and provided real-time support during system outages.",
        "Contributed to the enhancement of online learning platforms by implementing effective technical solutions.",
      ],
    },
    {
      companyName: "Digital Design for SERDES and FPGA Testing",
      companyLink: "#",
      role: "Researcher (Under Dr. Jayamala Adsul)",
      date: "2024",
      bullets: [
        "Conducted research and development in digital design for SERDES architecture under the guidance of Dr. Jayamala Adsul.",
        "Performed FPGA testing to validate design implementations and optimize performance.",
        "Collaborated with academic peers to refine design methodologies and testing protocols.",
      ],
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const activeExperience = experiences[activeIndex];

  return (
    <section className="experience section" id="experience">
      <h2 className="section-title">Where I&apos;ve Worked</h2>

      <div className="experience-container">
        {/* Left Side: Dynamic Tabs */}
        <ul className="experience-tabs">
          {experiences.map((exp, index) => (
            <li key={exp.companyName}>
              <div
                className={`tab-text ${
                  activeIndex === index ? "tab-active" : ""
                }`}
                onClick={() => setActiveIndex(index)}
              >
                {exp.companyName}
              </div>
            </li>
          ))}
        </ul>

        {/* Right Side: Experience Details with Fade-in Animation */}
        <div className="experience-content" key={activeIndex}>
          <h3 className="experience-role">
            {activeExperience.role}{" "}
            <span className="company-link">
              @{" "}
              <a
                href={activeExperience.companyLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {activeExperience.companyName}
              </a>
            </span>
          </h3>
          <p className="experience-date">{activeExperience.date}</p>
          <ul className="experience-bullets">
            {activeExperience.bullets.map((bullet, idx) => (
              <li key={idx}>
                <FaAngleRight className="bullet-icon" />
                {bullet}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Experience;
